import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const createChatTag = createAsyncThunk(
  'chatTag/createChatTag',
  async ({ name , group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id =loginToken?.response?.user?.business_id

      const response = await axios.post(
        `${ROOT_URL}/chat-tag`,
        { 
          name,
          business_id,
          group_id
        },
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          }
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const createChatTagSlice = createSlice({
  name: 'createChatTag',
  initialState,
  reducers: {
    resetCreateChatTagState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createChatTag.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(createChatTag.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
      })
      .addCase(createChatTag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      });
  }
});

export const { resetCreateChatTagState } = createChatTagSlice.actions;
export default createChatTagSlice.reducer; 